// extracted by mini-css-extract-plugin
module.exports = {"card":"bv_V","header":"bv_bf","logo":"bv_bW","link":"bv_cn","sharepoint":"bv_gF","oneDrive":"bv_gG","box":"bv_gH","body":"bv_dl","title":"bv_f","description":"bv_g"};